import React, { Component } from "react";
import { Fonts } from "../../Themes/Fonts";
import styles from "./styles.module.scss";


class FormTextArea extends Component {
  render() {
    const {
      meta: { touched, error },
      input: { onChange, value },
      placeholder,
      style,
      showCharacterCount,
    } = this.props;

    return (
      <div className={styles.container}>
        <textarea
          className={(touched && error) ? styles.textAreaError : styles.textArea}
          onChange={onChange}
          value={value}
          maxLength={200}
          placeholder={placeholder}
          style={style}
          resize={"none"}
        />
        {touched && error && <div style={Fonts.errorFont}>{error}</div>}
        { showCharacterCount && <div>{value.length}/200 characters</div>}
      </div>
    );
  }
}

export default FormTextArea;
